module.exports = __webpack_public_path__ + "img/money.7135e6c5.png";